import move1 from "../assets/audio/moves/piece-move-1.ogg";
import move2 from "../assets/audio/moves/piece-move-2.ogg";
import move3 from "../assets/audio/moves/piece-move-3.ogg";
import move4 from "../assets/audio/moves/piece-move-4.ogg";
import move5 from "../assets/audio/moves/piece-move-5.ogg";

const MOVE_URLS = [move1, move2, move3, move4, move5];

/**
 * Petit moteur audio : bruit de piece posee sur le plateau (enregistrement
 * reel, "Boardgame piece wobbles" par Aidan_Walker, CC0 — voir
 * src/assets/audio/moves/LICENSE.txt), joue via Web Audio API avec une
 * legere variation aleatoire de hauteur/volume pour eviter la repetition
 * mecanique d'un meme echantillon.
 */
export class SoundEngine {
  private ctx: AudioContext | null = null;
  private master: GainNode | null = null;
  private moveBuffers: AudioBuffer[] = [];

  /** A appeler suite a un geste utilisateur (les navigateurs l'exigent avant tout son). */
  ensureStarted(): void {
    if (this.ctx) {
      if (this.ctx.state === "suspended") void this.ctx.resume();
      return;
    }
    const ctx = new AudioContext();
    const master = ctx.createGain();
    master.gain.value = 0.8;
    master.connect(ctx.destination);
    this.ctx = ctx;
    this.master = master;
    void this.loadBuffers(ctx);
  }

  private async loadBuffers(ctx: AudioContext): Promise<void> {
    const results = await Promise.allSettled(
      MOVE_URLS.map(async (url) => {
        const res = await fetch(url);
        const data = await res.arrayBuffer();
        return await ctx.decodeAudioData(data);
      }),
    );
    this.moveBuffers = results
      .filter((r): r is PromiseFulfilledResult<AudioBuffer> => r.status === "fulfilled")
      .map((r) => r.value);
  }

  /** Bruit de piece posee sur le plateau : deplacement simple, capture, roque (x2), promotion. */
  pieceMove(): void {
    const ctx = this.ctx;
    const master = this.master;
    if (!ctx || !master || this.moveBuffers.length === 0) return;
    const buffer = this.moveBuffers[Math.floor(Math.random() * this.moveBuffers.length)]!;
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.playbackRate.value = 0.92 + Math.random() * 0.18;
    const gain = ctx.createGain();
    gain.gain.value = 0.55 + Math.random() * 0.15;
    source.connect(gain).connect(master);
    source.start();
  }
}

export const sound = new SoundEngine();
